import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import LoadingSkeleton from "./components/loading.jsx";
import ProtectedRoute from "./hooks/protectedRoute";
import TestPage from "./pages/testes/testPage.jsx";

const Home = React.lazy(() => import("./pages/dashboard/home/home.jsx"));
const EventosDashBoard = React.lazy(
  () => import("./pages/dashboard/events/events.jsx"),
);
const Eventos = React.lazy(
  () => import("./pages/dashboard/details/events/events.jsx"),
);
const AlarmesDashBoard = React.lazy(
  () => import("./pages/dashboard/alarms/alarmsDashboard.jsx"),
);
const AlarmesRealTime = React.lazy(
  () => import("./pages/dashboard/alarms/realtime/alarmsRealtime.jsx"),
);
const Logs = React.lazy(() => import("./pages/logs/logs"));
const AlarmesCadastro = React.lazy(
  () => import("./pages/register/alarms/alarmsRegister.jsx"),
);
const Ativos = React.lazy(() => import("./pages/register/assets/assets.jsx"));
const Usuarios = React.lazy(() => import("./pages/register/users/users.jsx"));
const Variaveis = React.lazy(
  () => import("./pages/register/variables/variables.jsx"),
);
const UsuariosGrupo = React.lazy(
  () => import("./pages/register/users/groups/usersGroups.jsx"),
);
const AtivosGrupo = React.lazy(
  () => import("./pages/register/assets/groups/assetsGroups.jsx"),
);
const Mapeamento = React.lazy(
  () => import("./pages/register/variables/mappings/mappings.jsx"),
);
const Perfil = React.lazy(() => import("./pages/profiles/profiles.jsx"));
const Detalhes = React.lazy(
  () => import("./pages/dashboard/details/general/detailsGeneral.jsx"),
);
const Operadores = React.lazy(
  () => import("./pages/register/operators/operators.jsx"),
);
// const DetalhesComponentes = React.lazy(
//   () => import("./pages/dashboard/details/components/detailsComponent.jsx"),
// );

const Login = React.lazy(() => import("./pages/login/login.jsx"));
const EsqueceuSenha = React.lazy(
  () => import("./pages/login/forgotPassword.jsx"),
);
const SemPermissao = React.lazy(
  () => import("./components/pageNoPermission.jsx"),
);
const NaoEncontrada = React.lazy(() => import("./components/pageNotFound.jsx"));

const Modelos = React.lazy(
  () => import("./pages/register/assets/models/models.jsx"),
);
// const Componentes = React.lazy(
//   () => import("./pages/register/assets/components/components.jsx"),
// );
// const Relatorio = React.lazy(() => import("./pages/relatories/relatories.jsx"));

// const Forecast = React.lazy(
//   () => import("./pages/dashboard/forecast/general/forecast.jsx"),
// );
// const ForecastDetalhes = React.lazy(
//   () => import("./pages/dashboard/forecast/details/forecastDetails.jsx"),
// );
const AlarmesComponente = React.lazy(
  () => import("./pages/maintaince/alarms/alarmsComponent.jsx"),
);
// const Servicos = React.lazy(
//   () => import("./pages/maintaince/services/services.jsx"),
// );

const AppRoutes = () => (
  <Suspense fallback={<LoadingSkeleton />}>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/esqueceuSenha" element={<EsqueceuSenha />} />
      <Route path="/testes" element={<TestPage />} />
      <Route path="/semPermissao" element={<SemPermissao />} />
      <Route
        exact
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/eventos"
        element={
          <ProtectedRoute>
            <EventosDashBoard />
          </ProtectedRoute>
        }
      />
      {/* <Route
       exact
      path="/forecast"
      element={
        <ProtectedRoute>
          <Forecast />
        </ProtectedRoute>
      }
    />
    <Route
      exact
      path="/forecast/:assetLabel"
      element={
        <ProtectedRoute>
          <ForecastDetalhes />
        </ProtectedRoute>
      }
    />*/}
      <Route
        path="/alarmes/dashboard/sumario"
        element={
          <ProtectedRoute>
            <AlarmesDashBoard apenasReconhecidos={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/historico"
        element={
          <ProtectedRoute>
            <AlarmesDashBoard apenasReconhecidos={false} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/temporeal"
        element={
          <ProtectedRoute>
            <AlarmesRealTime />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmesComponente"
        element={
          <ProtectedRoute>
            <AlarmesComponente />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/servicos"
        element={
          <ProtectedRoute>
            <Servicos />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/alarmes-cadastro"
        element={
          <ProtectedRoute module="register" action="alarms">
            <AlarmesCadastro />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos"
        element={
          <ProtectedRoute module="register" action="assets">
            <Ativos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios"
        element={
          <ProtectedRoute module="register" action="users">
            <Usuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/variaveis"
        element={
          <ProtectedRoute module="register" action="variables">
            <Variaveis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedRoute module="actions" action="logsView">
            <Logs />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/relatorios"
        element={
          <ProtectedRoute module="register" action="relatorios">
            <Relatorio />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/usuarios/grupo"
        element={
          <ProtectedRoute module="register" action="users">
            <UsuariosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos/grupo"
        element={
          <ProtectedRoute module="register" action="assets">
            <AtivosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos/modelos"
        element={
          <ProtectedRoute module="register" action="assets">
            <Modelos />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/ativos/componentes"
        element={
          <ProtectedRoute module="register" action="assets">
            <Componentes />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/variaveis/mapeamento"
        element={
          <ProtectedRoute module="register" action="variables">
            <Mapeamento />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operadores"
        element={
          <ProtectedRoute module="register" action="operators">
            <Operadores />
          </ProtectedRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <ProtectedRoute>
            <Perfil />
          </ProtectedRoute>
        }
      />
      <Route
        path="/detalhes/:assetLabel"
        element={
          <ProtectedRoute>
            <Detalhes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/detalhes/:assetLabel/eventos"
        element={
          <ProtectedRoute>
            <Eventos />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/detalhes/:assetLabel/componentes"
        element={
          <ProtectedRoute>
            <DetalhesComponentes />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <NaoEncontrada />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Suspense>
);

export default AppRoutes;
